import React, { useState } from 'react';
import Rodal from 'rodal';
import { Form } from 'informed';
import { IDocument } from '../../common/types';
import { InputTypeArea } from '../../../elements';
import Axios, { AxiosError } from 'axios';
import { API_URL } from '../../../../lib/const';
import { IApplication } from '../types';
import { IFormApi } from '../../types';
import { toast } from 'react-toastify';


type TFormValues = {
  documentId: number
  reason: string,
  result: 'Approved' | 'Reproved'
}

type TransferApplicationDocumentAnalysisModalProps = {
  show: boolean,
  application: IApplication,
  document: IDocument,
  onClose: () => void,
  onConfirm: (data: TFormValues) => void,
  analysisResult: 'Approved' | 'Reproved'
}

const TransferApplicationDocumentAnalysisModal = ({ show, onClose, document, analysisResult, onConfirm, application }: TransferApplicationDocumentAnalysisModalProps) => {
  const [submitting, setSubmitting] = useState(false);

  const handleConfirm = (formApi: IFormApi, values: TFormValues) => {
    setSubmitting(true);

    Axios.post(`${API_URL}/transfers/applications/${application.token}/documents/${document.id}/review`, values)
      .then(() => onConfirm(values))
      .catch(error => {
        const response = (error as AxiosError).response;

        if (response && response.status === 400) {
          const errors = response.data;

          formApi.setError('reason', null);
          if (errors.reason) {
            formApi.setError('reason', errors.reason as string[]);
          }

          if (errors.non_field_errors) {
            toast.error(errors.non_field_errors.join(','))

          } else {
            toast.error('Ocorreu um erro ao analisar o documento.')

          }

        } else {
          toast.error('Ocorreu um erro desconhecido ao analisar o documento.')

        }
      })
      .finally(() => setSubmitting(false))
  }

  return (
    <Rodal
      width={600}
      height={analysisResult === 'Reproved' ? 415 : 250}
      visible={show}
      onClose={onClose}
    >
      <div className="d-flex flex-column h-100">
        <div className="modal-header">
          <div className="text-center">
            <h2>Deseja {analysisResult === 'Approved' ? 'aprovar' : 'reprovar'} o documento ?</h2>
          </div>
        </div>
        <div className="modal-body">
          <div className="enrollment-flex">
            <Form className="w-100" key={document.id} initialValues={{ documentId: document.id, reason: '', result: analysisResult }}>
              {({ formApi, formState }: { formApi: IFormApi, formState: { values: TFormValues } }) => (
                <>
                  <p className="col-md-12"><strong>Nome:</strong> {document.name}</p>
                  <p className="col-md-12"><strong>Tipo:</strong> {document.type && document.type.name}</p>
                  {analysisResult === 'Reproved' && <InputTypeArea row="5" col="12" label="Motivo" field="reason" />}
                  <div className="text-right">
                    <div className="col-md-4 p-0 offset-md-8 col-sm-12">
                      <div className="btn-actions">
                        <button
                          className={`btn btn-${analysisResult === 'Approved' ? 'primary' : 'danger'}`}
                          onClick={() => handleConfirm(formApi, formState.values)}
                          disabled={submitting}
                          type="submit"
                        >
                          {analysisResult === 'Approved' ? 'Aprovar' : 'Reprovar'}
                        </button>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </Form>
          </div>
        </div>
      </div>
    </Rodal>
  )
}

export default TransferApplicationDocumentAnalysisModal;
